import React from 'react'
import { Link } from 'react-router-dom'

const NotFoundPage = () => (
  <div className="grid-container page">
    404 - Page not found. <Link className="underline" to="/start">Go back to the start</Link>
  </div>
)

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js